// retoursVenteMobileShared.js — helpers de l'écran « Retour de vente » mobile.
//
// Les formules de totaux et la coercition décimale sont STRICTEMENT identiques à celles du
// retour d'achat : on les réexporte au lieu de les dupliquer.
import { num } from "../achats/retoursMobileShared";

export {
  QUANTITY_DECIMALS,
  MIN_RETURN_QUANTITY,
  num,
  fmtDate,
  parseDecimal,
  computeTotals,
  paymentPill,
  paymentStatusOf,
} from "../achats/retoursMobileShared";

const ROOT = "Gestion Commerciale.Ventes.RetourVente";
export const PERM = {
  view: `${ROOT}.view`,
  create: `${ROOT}.create`,
  edit: `${ROOT}.edit`,
  delete: `${ROOT}.delete`,
};

/** Statuts proposés par le formulaire desktop (GestionRetourVente.tsx:2760-2762). */
export const ORDER_STATUS_OPTIONS = [
  { value: "pending", label: "En attente" },
  { value: "completed", label: "Complété" },
  { value: "cancelled", label: "Annulé" },
];

const CANCELLED = new Set(["annulé", "cancelled"]);
const PENDING = new Set(["en attente", "pending"]);

/**
 * Statut de la commande → ton de `Pill`.
 *
 * Le desktop est incohérent : le formulaire enregistre « pending / completed / cancelled »
 * (l.2760-2762) alors que ses maps de couleurs attendent « en attente / complété / annulé »
 * (l.3631-3636). Un retour créé depuis l'interface s'affiche donc sans couleur. On accepte
 * ici les deux orthographes — c'est purement de l'affichage, aucune donnée n'est modifiée.
 */
export const orderPill = (record) => {
  const s = String(record.order_status || "En attente");
  const k = s.toLowerCase();
  if (CANCELLED.has(k)) return { tone: "danger", label: "Annulé" };
  if (PENDING.has(k)) return { tone: "draft", label: "En attente" };
  return { tone: "ok", label: "Complété" };
};

export const isCancelled = (record) => CANCELLED.has(String(record.order_status || "").toLowerCase());

/**
 * Actions destructives — le desktop du retour de VENTE n'expose QUE « Supprimer »
 * (colonne l.3667-3690, pied du modal de détail l.1344-1373). `cancelRetourVente` et
 * `restoreRetourVente` existent dans la classe API mais ne sont branchés sur aucun bouton :
 * le mobile ne les expose pas non plus, pour ne pas faire diverger les deux plateformes.
 *
 * Le modal desktop DÉSACTIVE le bouton quand `is_deletable === 0` ; faute d'état désactivé
 * sur `ActionRow`, on masque la ligne dans ce cas.
 */
export const canDeleteReturn = (record, canDelete) =>
  Boolean(canDelete) && record.is_deleted !== 1 && record.is_deletable !== 0;

/** Le pied du modal de détail masque « Modifier » si supprimé, et le désactive si déjà payé (l.1325-1342). */
export const isEditBlocked = (record) => record.is_deleted === 1 || num(record.paid_amount) > 0;

/** « Ajouter un paiement » (remboursement) — condition desktop l.1388 / l.1679. */
export const canRefund = (record) => num(record.due_amount) > 0 && !isCancelled(record);

export const clientNameOf = (record, clients = []) => {
  if (record.user_name) return record.user_name;
  const c = clients.find((x) => x.id === record.user_id);
  return c?.name || `Client #${record.user_id}`;
};
